import { FC, useEffect, useRef } from 'react'
import styled from 'styled-components'
import ReactRangeSlider from 'react-range-slider-input'
import { Grid, GridCol } from '../../Grid/desktop'
import { TextField } from '../../TextField/desktop'
import 'react-range-slider-input/dist/style.css'
import { IRangeSlider } from '../types'
import { Spacing } from '../../Spacing/desktop'
import { onEnter } from '../bll'

const Block = styled.div``

const SliderBox = styled.div`
  position: relative;
`

const RangeSlider: FC<IRangeSlider> = (props) => {
  const { max = 0, min = 999999, values, setValues, step, afterChange } = props
  const refMax = useRef<HTMLTextAreaElement>(null)
  const refMin = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    onEnter(refMin, afterChange, undefined, values.max)
    onEnter(refMax, afterChange, values.min)
  }, [refMax, refMin, afterChange])

  return (
    <Block>
      <Grid spacing='small'>
        <GridCol width='50%'>
          <TextField
            type='number'
            label='От'
            value={values.min}
            max={max}
            min={0}
            onBlur={(e) => {
              setValues((prev) => {
                if (Number(e.target.value) > values.min) {
                  if (afterChange) {
                    afterChange(prev.max, values.max)
                  }

                  return {
                    min: prev.max,
                    max: values.max,
                  }
                }

                if (afterChange) {
                  afterChange(Number(e.target.value), prev.max)
                }

                return {
                  min: Number(e.target.value),
                  max: values.min,
                }
              })
            }}
            ref={refMin}
          />
        </GridCol>

        <GridCol width='50%'>
          <TextField
            type='number'
            label='До'
            value={values.max}
            min={0}
            onBlur={(e: any) => {
              setValues((prev) => {
                if (Number(e.target.value) < values.min) {
                  if (afterChange) {
                    afterChange(prev.min, values.min)
                  }

                  return {
                    min: prev.min,
                    max: values.min,
                  }
                }

                if (afterChange) {
                  afterChange(prev.min, Number(e.target.value))
                }

                return {
                  max: Number(e.target.value),
                  min: values.min,
                }
              })
            }}
            ref={refMax}
          />
        </GridCol>
      </Grid>

      <Spacing spacing='large' />

      <Grid spacing='xxsmall'>
        <GridCol width='100%'>
          <SliderBox className='range-slider'>
            <ReactRangeSlider
              className='range-slider-custom'
              min={min}
              max={max}
              defaultValue={[values.min, values.max]}
              value={[values.min, values.max]}
              step={step}
              onInput={(arrNum) => {
                setValues((prev) => {
                  if (arrNum[0] >= arrNum[1]) {
                    return {
                      min: prev.min,
                      max: prev.max,
                    }
                  }

                  return {
                    min: arrNum[0],
                    max: arrNum[1],
                  }
                })
              }}
              onThumbDragEnd={() => {
                if (afterChange) {
                  afterChange(values.min, values.max)
                }
              }}
            />
          </SliderBox>
        </GridCol>
      </Grid>
    </Block>
  )
}

export default RangeSlider
